<template>
  <section>
    <section-heading v-if="restListLarge.addressEntered">{{
      addressEnteredRestListTitle
    }}</section-heading>
    <section-heading v-else>{{ restListTitle }}</section-heading>
    <ul class="large-card-list">
      <li
        v-for="rest in filterableRestList"
        class="large-card-list-item"
        :key="rest.id"
      >
        <card-large
          @showLaterOrderModal="showLaterOrderModal"
          :restId="rest.id"
          :name="rest.name"
          :waitTime="rest.waitTime"
          :openTime="rest.openTime"
          :open="rest.open === 1"
          :acceptsDelivery="rest.acceptsDelivery"
          :acceptsPickup="rest.acceptsPickup"
          :categories="rest.categories"
          :image="rest.image"
          :url="rest.url"
          :hours="rest.hours"
          :deliveryFee="rest.fee"
          :distance="rest.distance"
        />
      </li>
      <li v-if="filterableRestList.length === 0">
        <p class="no-results">
          Sorry, no results matching that name/category...
        </p>
      </li>
    </ul>
    <modal v-if="showLaterOrder" @hideModal="hideLaterOrderModal">
      <later-order-same-hours
        @goToMenu="
          hideLaterOrderModal()
          goToMenu()
        "
        :restId="restId"
        :hours="hours"
        :restName="restName"
      ></later-order-same-hours>
    </modal>
  </section>
</template>

<script>
import CardLarge from './CardLarge.vue'
import SectionHeading from './SectionHeading.vue'
import Modal from '../../address-components/Modal.vue'
import LaterOrderSameHours from './LaterOrderSameHours.vue'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'CardLargeList',
  // commenting this out for now, when the project is in it's later stages, CardLargeList will no longer be the parent component and will get its data via props.
  // props: {
  // 		title: String,
  // 		cards: {
  // 				type: Array,
  // 				default: () => []
  // 		}
  // },
  components: {
    CardLarge,
    SectionHeading,
    Modal,
    LaterOrderSameHours,
  },
  mounted() {
    this.setInitRestListState()
  },
  computed: {
    ...mapState({
      restListLarge: (state) => state.restList.restListLarge,
      filterableRestList: (state) => state.restList.filterableRestList,
    }),
    restListTitle: function () {
      if (this.restListLarge.titleFilter && this.restListLarge.titleMarket) {
        return (
          'All ' +
          this.restListLarge.titleMarket +
          ' ' +
          this.restListLarge.titleFilter +
          ' Restaurants'
        )
      } else if (this.restListLarge.titleMarket) {
        return 'All ' + this.restListLarge.titleMarket + ' Restaurants'
      } else {
        return 'All Restaurants'
      }
    },
    addressEnteredRestListTitle: function () {
      if (this.restListLarge.titleFilter && this.restListLarge.titleMarket) {
        return (
          this.restListLarge.titleMarket +
          ' ' +
          this.restListLarge.titleFilter +
          ' Restaurants Closest To You'
        )
      } else if (this.restListLarge.titleMarket) {
        return this.restListLarge.titleMarket + ' Restaurants Closest To You'
      } else {
        return 'All Restaurants Closest To You'
      }
    },
  },
  data: function () {
    return {
      hours: {},
      restName: '',
      url: '',
      restId: '',
      showLaterOrder: false,
    }
  },
  methods: {
    ...mapActions({
      setInitRestListState: 'restList/setInitRestListState',
    }),
    showLaterOrderModal(payload) {
      document.body.classList.add('not-scrollable')
      this.hours = payload.hours
      this.restName = payload.restName
      this.url = payload.url
      this.restId = payload.restId
      this.showLaterOrder = true
      this.$nextTick(function () {
        document.getElementById('later-datepicker').focus()
      })
    },
    hideLaterOrderModal() {
      document.body.classList.remove('not-scrollable')
      this.showLaterOrder = false
    },
    goToMenu() {
      window.location.href = this.url
    },
  },
}
</script>

<style lang="scss" scoped>
.large-card-list-item {
  margin-bottom: $card-spacing;
}
</style>
<style>
#modal-background {
  background-color: #000;
  opacity: 0.5;
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
}
.not-scrollable {
  overflow: hidden;
}
.modal {
  overflow-x: hidden;
  overflow-y: auto;
}
.modal-loading {
  display: block;
  text-align: right;
  margin-top: 5px;
  margin-right: 2px;
}
.vdp-datepicker__calendar .cell.selected:hover {
  background: #0083c6 !important;
  color: white !important;
}
.vdp-datepicker__calendar .cell.selected {
  background: #0083c6 !important;
  color: white !important;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #0083c6 !important;
}
.no-results {
  font-style: italic !important;
  font-size: 16px !important;
}
</style>
